import React from 'react';
import styled from "styled-components";
import axios from 'axios'
import {baseURL} from "../services/authentication.js"
import refe from "../imgs/refe.jpeg"
//import {getToken} from "../services/authentication.js"

const Contenedor=styled.div`
	display:flex;
	position:relative;
	background-image:url(${refe});
	background-size:cover;
	height:100vh `

const Formulario=styled.form`
	display:flex;
	position:absolute;
	top:10vh;
	left:4vw;
	flex-direction:column;	
	position:relative;
	height:100vh;	
	@media (max-width:700px){
	width:100%}
`;


const ImputsReferidos=styled.input`
	display:inline;
	margin:10px;
	height:25px;
	width:300px;
	border-radius:10px;
	border: 2px solid #BEBABA;
	font-size:13px;
	@media (max-width:700px){
	margin:7px}
`;


const TipoDatos=styled.div`
	color:#09b5c1;
	font-size:25px
`; 

const ButonStyle=styled.button`  
	width: 120px;
	padding:5px;
	margin:20px;
	border-radius:8px;
	border:none;
	font-family: 'Poppins', sans-serif;
	background-color:#09b5c1;
	display:block
`
const Mesagge=styled.div` 
display:flex;
text-align:center;
font-family: 'Poppins', sans-serif;
flex-direction:column;
width:59vw;
position:absolute;
top: 15vh;
right:3vw;
align-items:center;
 @media (max-width:650px){
	          position:absolute;
	          top:4vh;width:100%}
  `;


const Mesagge1=styled.div` 
text-align:center;
position:relative;
display:flex;
align-items:center;
font-size:70px;
color:#033953;
@media(max-width:950px){
	width:55vw;
	font-size:70px
};
@media(max-width:850px){
	width:30vw;
	font-size:40px}
 @media (max-width:650px){
 			  font-size:20px;
	          width:100%;
	          color:red;justify-content:center}


  `;


const Mesagge2=styled.div` 
text-align:center;
position:relative;
display:flex;
justify-content:center;
align-items:center;
font-size:24px;
color:red;
@media (max-width:650px){
	          display:none}

  `;


export default function Referidos(){

	let readyForSend={nombre:0,apellido:0,numero:0,relacion:0,nombreReferido:0, apellidoReferido:0,numeroReferido:0};
	//const token=getToken();


	let ValidateReadyForSend=()=>{
		const suma = Object.keys(readyForSend).reduce((anterior, actual) => anterior + readyForSend[actual], 0);
	  if(suma===7){return true} else return false};

	 let changeAtError=(id,valor)=>{

		let etiqueta=document.getElementById(id);
		etiqueta.style.border=valor;
	};		
		

	let validate=(e)=>{
		let etiqueta=e.target;
		let validarNoNumeros=new RegExp('[0-9]');		
		let validarLetras=new RegExp('[a-zA-Z]');	
		let bordeError="2px solid red";
		let bordeAcept="2px solid #42C858";
		
		if(etiqueta.id==="numero"||etiqueta.id==="numeroReferido"){	
				if(validarLetras.test(etiqueta.value)||etiqueta.value===""||etiqueta.value===" "){
					changeAtError(etiqueta.id,bordeError);readyForSend[etiqueta.id]=0}
		 		 else { changeAtError(etiqueta.id,bordeAcept);readyForSend[etiqueta.id]=1} }
		
		else{
				if(validarNoNumeros.test(etiqueta.value)|| etiqueta.value===""||etiqueta.value===" ")
					{changeAtError(etiqueta.id,bordeError);readyForSend[etiqueta.id]=0}
				else{changeAtError(etiqueta.id,bordeAcept);readyForSend[etiqueta.id]=1};
		}	
	}	
	

	let limpiar=(array)=>{array.forEach(name=>document.getElementById(name).value="")};	

	let handleSubmit=(e)=>{
		e.preventDefault();
		if(ValidateReadyForSend()){	
			axios.post(baseURL+"/referidos",{nombre:document.getElementById("nombre").value,
		                                         apellido:document.getElementById("apellido").value,
		                                         numero:document.getElementById("numero").value,
		                                         relacion:document.getElementById("relacion").value,
		                                         nombreReferido:document.getElementById("nombreReferido").value,
		                                         apellidoReferido:document.getElementById("apellidoReferido").value,
		                                         numeroReferido:document.getElementById("numeroReferido").value},
		                                         //{headers:{ Authorization:`Bearer ${token}`} }
		                                         )
			.then(function (response) { console.log(response)})
	  	.catch(function (error) {console.log(error)}
	  	);	

			alert("DATOS ENVIADOS");
			limpiar(["nombre","apellido","numero","relacion","nombreReferido","apellidoReferido","numeroReferido"])	
		}else{ alert("VERIFICAR DATOS")};	
	}				

	return(	

			<Contenedor>
				<Formulario  onSubmit={handleSubmit}>					
						<TipoDatos><b>tus datos:</b></TipoDatos>
					    <ImputsReferidos id="nombre" onChange={validate} placeholder="Tus nombres: " type="text"/>
						<ImputsReferidos id="apellido" onChange={validate} placeholder="Tus apellidos:" type="text"/>
						<ImputsReferidos id="numero" onChange={validate} placeholder="Tu numero de contacto:" type="tel"/>
						<ImputsReferidos id="relacion" onChange={validate} placeholder="Tu relacion con el referido:" type="text"/>
						<TipoDatos><b>datos del referido:</b></TipoDatos>
						<ImputsReferidos id="nombreReferido" onChange={validate} placeholder="Nombre del referido:" type="text"/>
						<ImputsReferidos id="apellidoReferido" onChange={validate} placeholder="Apellido del referido" type="text"/>
						<ImputsReferidos id="numeroReferido" onChange={validate} placeholder="Numero de contacto del referido" type="phone"/>
						<ButonStyle >enviar</ButonStyle>					
				</Formulario>
				<Mesagge>
					<Mesagge1><b>Acede a un descuento o bono por referido!</b></Mesagge1>
					<Mesagge2><i>*envianos tus datos y los de tu referido para poder contactarlo</i></Mesagge2>
				</Mesagge>


						

			
			</Contenedor>		
	)
}

export {Referidos,ImputsReferidos,Formulario,ButonStyle}